import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

export default function PageShell({ children, testId }) {
  return (
    <div data-testid={testId} className="relative">
      <Navbar />
      <main className="pt-20">{children}</main>
      <Footer />
    </div>
  );
}
